import { makeStyles } from "@material-ui/core";
import { MasterButton } from "App/Component/ui";
import { DEFAULT_BOX_SHADOW, instance4, PRIMARY_BACKGROUND } from "App/constants";
import { isNull, oneMonthBeforeToday, today } from "App/utils/helpers";
import moment from "moment";
import React from "react";

export const urlUpload = '/wmsAsset/asset/upload-asset';
export const urlAccess = '/wmsassets/transaksi/fixasset/management_acces'
export const urlGet = "/wmsAsset/asset/list";
const urlDelete = "/wmsAsset/asset/delete";

export const checkAcessAsset = async () => {
    try{
        const statusCheck = await instance4.post(urlAccess)
        const res = statusCheck.data;
        if(res.status === 200){
            return {
                status: true,
                access : res.result
            }
        }else{
            return {
                status: false,
                message : res.message
            }
        }
    }catch(err){
        return {
            status: false,
            message :  err?.response?.data?.message,
        }
    }
   
}

export const headCellsSuccess = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "center",
    sort: true,
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    sort: true,
    minWidth: "200px",
  },
];

export const STYLE_MASTER_FA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "merek",
    disablePadding: false,
    label: "MEREK",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "type",
    disablePadding: false,
    label: "TYPE",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "idgl",
    disablePadding: false,
    label: "IDGL",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "id_pembelian",
    disablePadding: false,
    label: "ID PEMBELIAN",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "type_asset",
    disablePadding: false,
    label: "TIPE ASSET",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "status_kelengkapan",
    disablePadding: false,
    label: "STATUS KELENGKAPAN",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "nilaiAsset",
    disablePadding: false,
    label: "NILAI ASSET",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "kondisi_barang",
    disablePadding: false,
    label: "KONDISI BARANG",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "no_sn",
    disablePadding: false,
    label: "NOMOR SN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_akd",
    disablePadding: false,
    label: "NOMOR AKD",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_akl",
    disablePadding: false,
    label: "NOMOR AKL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nofaktur",
    disablePadding: false,
    label: "NOMOR FAKTUR",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "gudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "supplier",
    disablePadding: false,
    label: "SUPPLIER",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "produsen",
    disablePadding: false,
    label: "PRODUSEN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tgl_pembelian",
    disablePadding: false,
    label: "TGL PEMBELIAN",
    align: "left",
    minWidth: "150px",
  },
  //   {
  //   id: "remark",
  //   disablePadding: false,
  //   label: "KETERANGAN",
  //   align: "left",
  //   minWidth: "200px",
  // },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },

  // {
  //   id: "nofaktur",
  //   disablePadding: false,
  //   label: "NO. FAKTUR",
  //   align: "left",
  //   minWidth: "100px",
  // },

  // {
  //   id: "tgl_pemakaian",
  //   disablePadding: false,
  //   label: "TGL PEMAKAIAN",
  //   align: "left",
  //   minWidth: "180px",
  // },
  // {
  //   id: "tgl_akhirpenyusutan",
  //   disablePadding: false,
  //   label: "TGL PENYUSUTAN",
  //   align: "left",
  //   minWidth: "180px",
  // },

  // {
  //   id: "tarif_penyusutan",
  //   disablePadding: false,
  //   label: "TARIF PENYUSUTAN",
  //   align: "left",
  //   minWidth: "200px",
  // },

  // {
  //   id: "total_jumlah",
  //   disablePadding: false,
  //   label: "TOTAL JUMLAH",
  //   align: "left",
  //   minWidth: "180px",
  // },

  // {
  //   id: "nilai_sisaditaksir",
  //   disablePadding: false,
  //   label: "NILAI SISA DITAKSIR/RESIDU",
  //   align: "left",
  //   minWidth: "250px",
  // },

  // {
  //   id: "total_penyusutan",
  //   disablePadding: false,
  //   label: "TOTAL PENYUSUTAN",
  //   align: "left",
  //   minWidth: "200px",
  // },

  // {
  //   id: "total_cicilan",
  //   disablePadding: false,
  //   label: "CICILAN",
  //   align: "left",
  //   minWidth: "150px",
  // },

  // {
  //   id: "sisa_pemby",
  //   disablePadding: false,
  //   label: "SISA",
  //   align: "left",
  //   minWidth: "150px",
  // },

  // {
  //   id: "status",
  //   disablePadding: false,
  //   label: "STATUS",
  //   align: "left",
  //   minWidth: "100px",
  // },
];



export const RESET_STATE_FORM_FILTER = {
  id: "",
  pembelian_id: "",
  search: "",
  supplier_id: "",
  supplier: "Pilih Supplier",
  produsen_id: "",
  produsen: "Pilih Produsen",
  gudang_id: "",
  gudang: "Pilih Gudang",
  tglAwal: oneMonthBeforeToday(),
  tglAkhir: today(),
  halaman: 1,
  jumlah: 10,
  status_kelengkapan:"",
  status_kelengkapan_nama:"SEMUA",
  tgl_aktif: true,
  type_assets_id:"",
  type_assets_name:"Pilih TIpe Asset",
};

export const getByFilterFA = async (formFilter, pages, limit) => {
  try {
    const api = await instance4.post(urlGet, {
      id:parseInt(formFilter.id),
      status_kelengkapan:formFilter.status_kelengkapan,
      pembelian_id: formFilter.pembelian_id,
      supplier_id: formFilter.supplier_id,
      gudang_id: formFilter.gudang_id,
      produsen_id: formFilter.produsen_id,
      type_assets_id: formFilter.type_assets_id,
      search: formFilter.search,
      tglAwal: !isNull(formFilter.tglAwal) ? moment(formFilter.tglAwal).format("YYYY-MM-DD") : "",
      tglAkhir: !isNull(formFilter.tglAkhir) ? moment(formFilter.tglAkhir).format("YYYY-MM-DD") : "",
      pages: pages,
      limit: limit,
      unit_id: formFilter?.unit_id,
      withFilterUnit: formFilter?.withFilterUnit,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.meta.count),
          pages: parseInt(res.meta.pages),
          limit: parseInt(res.meta.limit),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const RenderStatusKelengkapanBadge = ({ status }) => {
  if (status === 0 || status === null) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"BELUM LENGKAP"}
        color={"secondary"}
        type='button'
        disabled
      />
    );
  } else if (status === 1) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"SUDAH LENGKAP"}
        color={"green"}
        type='button'
        disabled
      />
    );
  } else {
    return <p> Tidak ditemukan</p>;
  }
};

export const deleteFixedAssetById = async (id) => {
  try {
    await instance4.post(urlDelete, { id });

    return {
      state: true,
      message: "Data berhasil dihapus",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getByFilterFixedAssetExport = async (formFilter) => {
  try {
    const api = await instance4.post("/wmsAsset/asset/list-export", {
      id:parseInt(formFilter.id),
      status_kelengkapan:formFilter.status_kelengkapan,
      pembelian_id: formFilter.pembelian_id,
      supplier_id: formFilter.supplier_id,
      gudang_id: formFilter.gudang_id,
      produsen_id: formFilter.produsen_id,
      type_assets_id: formFilter.type_assets_id,
      search: formFilter.search,
      tglAwal: !isNull(formFilter.tglAwal) ? moment(formFilter.tglAwal).format("YYYY-MM-DD") : "",
      tglAkhir: !isNull(formFilter.tglAkhir) ? moment(formFilter.tglAkhir).format("YYYY-MM-DD") : "",
      unit_id: formFilter?.unit_id,
      withFilterUnit: formFilter?.withFilterUnit,
    });
    const res = api.data;
    return {
      state: true,
      data: res.data,
      meta: res.meta,
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};